export default __webpack_public_path__ + "static/char-thumb-07-78db5aa0cf274d38279d610e2473f0f9.png";